import styled from 'styled-components';
import { Button } from 'ui-components/src/components/atoms/Button';
import { CrossIcon } from 'ui-components/src/components/atoms/icons/CrossIcon';

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.header`
  display: flex;
`;

export const HeaderContent = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 1rem;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.lightGrey}`};

  > h4 {
    margin: 0;
    user-select: none;
  }
`;

export const CloseButton = styled.button`
  width: 65px;
  height: 65px;
  background-color: ${({ theme }) => theme.colors.primary.cyan};
  border: 0;
  outline: 0;
  cursor: pointer;

  &:hover {
    filter: brightness(0.9);
  }
`;

export const ActionButton = styled(Button)`
  line-height: 38px;
  height: 38px;
  border-radius: 4px;
`;

export const CloseIcon = styled(CrossIcon)`
  height: 1rem;
  width: 1rem;
  fill: ${({ theme }) => theme.colors.primary.white};
`;

export const SubHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 50px;
  height: 50px;
  padding: 0 ${(props) => props.theme.spacing['8px']};
  background-color: ${({ theme }) => theme.colors.primary.white};
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.lightGrey}`};
`;
